export default function initBsrSubNavigation() {
    const elements = document.querySelectorAll('.bsr-sub-navigation');
    const buttonHiddenClassname = 'bsr-sub-navigation__scrollButton--hidden';

    elements.forEach((element) => {
        const nextButton = element.querySelector('.bsr-sub-navigation__scrollButton--next');
        const prevButton = element.querySelector('.bsr-sub-navigation__scrollButton--prev');

        const scrollContainer = element.querySelector('.bsr-sub-navigation__scrollContainer');

        nextButton.addEventListener('click', () => {
            scrollContainer.scrollBy({
                top: 0,
                left: 100,
                behavior: "smooth",
            });
        });

        prevButton.addEventListener('click', () => {
            scrollContainer.scrollBy({
                top: 0,
                left: -100,
                behavior: "smooth",
            });
        });


        const isScrollable = () => scrollContainer.scrollWidth > scrollContainer.offsetWidth;
        const canScrollLeft = () => scrollContainer.scrollLeft > 0;
        const canScrollRight = () => scrollContainer.scrollLeft < (scrollContainer.scrollWidth - scrollContainer.offsetWidth);
        
        const debounce = (func, delay) => {
            let timeout;
            const debounced = (...args) => new Promise((resolve) => {
                clearTimeout(timeout);
                timeout = setTimeout(() => resolve(func(...args), delay));
            })
            return debounced;
        }
        
        const handleScroll = () => {
            if(canScrollLeft()) {
                prevButton.classList.remove(buttonHiddenClassname);
            } else {
                prevButton.classList.add(buttonHiddenClassname);
            }
            if(canScrollRight()) {
                nextButton.classList.remove(buttonHiddenClassname);
            } else {
                nextButton.classList.add(buttonHiddenClassname);
            }
        };

        const handleResize = () => {
            if(!isScrollable()) {
                prevButton.classList.add(buttonHiddenClassname);
                nextButton.classList.add(buttonHiddenClassname);
            } else {
                handleScroll();
            }
        };

        handleResize();
        scrollContainer.addEventListener('scroll', debounce(handleScroll, 100));
        window.addEventListener('resize', debounce(handleResize, 100));
    });
}